import type { ComponentType } from "react";

export type ModalPropStyle = "open" | "isOpen";

export type SandboxItem = {
  id: string;
  category: "Modals" | "Buttons" | "Cards" | "Forms" | "Other";
  label: string;
  description?: string;
  load: () => Promise<{ default: ComponentType<unknown> }>;
  props?: Record<string, unknown>;
  wrapper: "modal" | "inline";
  modalPropStyle?: ModalPropStyle;
};

const sandboxItems: SandboxItem[] = [
  {
    id: "donate-modal",
    category: "Modals",
    label: "Donate Modal",
    description: "Модалка доната (как на /about)",
    load: () =>
    import("@/widgets/marketing/donate-modal").then((m) => ({ default: m.DonateModal as ComponentType<unknown> })),
    wrapper: "modal",
    modalPropStyle: "open",
  },
  {
    id: "match-stats-modal",
    category: "Modals",
    label: "Match Stats Modal",
    description: "Модалка лайв-статистики матча",
    load: () =>
      import("@/widgets/bracket/match-stats-modal").then((m) => ({ default: m.MatchStatsModal as ComponentType<unknown> })),
    props: {
      matchId: "test",
      teamA: { id: "t1", name: "Синие" },
      teamB: { id: "t2", name: "Красные" },
      status: "live" as const,
      testMode: true,
    },
    wrapper: "modal",
    modalPropStyle: "isOpen",
  },
];

export const UI_SANDBOX_ITEMS = sandboxItems;

export const SANDBOX_CATEGORIES = ["Modals", "Buttons", "Cards", "Forms", "Other"] as const;
